<template>
  <div v-if="!product.title.includes('E-Gift Card')" class="product-stock-info">
    <template v-if="!isATCDisabled">
      <p class="product-stock-info__sentence">
        <!-- Final Sale Message -->
        <span v-if="product.final_sale_msg" class="product-stock-info__finalSale">
          {{ product.final_sale_msg }}
        </span>

        <!-- Separator pipe if both final sale and low stock -->
        <span v-if="product.final_sale_msg && isLowStock" class="product-stock-info__seperator">|</span>

        <!-- Inventory Message -->
        <span v-if="!selectedFirstOption.bis && isLowStock" class="product-stock-info__inventory-msg">
          {{ selectedVariant.inventory_quantity }} Left in Stock
        </span>

        <!-- Back In Stock Message -->
        <span
          v-else-if="selectedFirstOption.bis && selectedFirstOption.bisDate != 'N/A' && !selectedVariant.available"
          class="product-stock-info__inventory-msg"
        >
          Estimated in stock date: {{ selectedFirstOption.bisDate }}
        </span>
      </p>
    </template>

    <template v-else>
      <div class="product-stock-info__inventory-out-of-stock-msg">
        The last in-stock item for your selection is already in your cart. Check out now before it's gone for good!
      </div>
    </template>
  </div>
</template>

<script setup>
  import { computed, toRefs } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({}),
    },
    selectedVariant: {
      type: Object,
      default: () => ({}),
    },
    selectedFirstOption: {
      type: Object,
      default: () => ({}),
    },
    isATCDisabled: {
      type: Boolean,
      default: false,
    },
  });

  const { product, selectedFirstOption, selectedVariant } = toRefs(props);

  const isLowStock = computed(() => {
    return selectedVariant.value && product.value.units_left_threshold > selectedVariant.value.inventory_quantity;
  });
</script>
